import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface Model {
  id: string;
  name: string;
  provider: string;
}
interface ModelSelectorProps {
  selectedModel: Model;
  onSelectModel: (model: Model) => void;
}
export function ModelSelector({
  selectedModel,
  onSelectModel
}: ModelSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const models: Model[] = [{
    id: 'llama3-8b',
    name: 'Llama 3',
    provider: 'Meta'
  }, {
    id: 'llama3-70b',
    name: 'Llama 3 (70B)',
    provider: 'Meta'
  }, {
    id: 'deepseek-v3',
    name: 'DeepSeek V3.1',
    provider: 'DeepSeek'
  }, {
    id: 'gemma-3',
    name: 'Gemma 3',
    provider: 'Google'
  }, {
    id: 'mistral-3',
    name: 'Mistral 3',
    provider: 'Mistral AI'
  }];
  return <div className="relative" data-id="element-63">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center px-3 py-2 bg-blue-900/30 text-blue-400 rounded-md hover:bg-blue-900/50 transition-colors border border-blue-800" data-id="element-64">
        <span className="mr-1" data-id="element-65">
          {selectedModel.name} ({selectedModel.provider})
        </span>
        <ChevronDownIcon size={16} data-id="element-66" />
      </button>
      {isOpen && <div className="absolute top-full left-0 mt-1 w-48 bg-[#0F0F0F] rounded-md shadow-lg z-10 border border-[#333333]" data-id="element-67">
          <ul className="py-1" data-id="element-68">
            {models.map(model => <li key={model.id} data-id="element-69">
                <button onClick={() => {
            onSelectModel(model);
            setIsOpen(false);
          }} className={`w-full text-left px-4 py-2 text-sm hover:bg-[#1a1a1a] ${selectedModel.id === model.id ? 'bg-blue-900/30 text-blue-400' : 'text-gray-300'}`} data-id="element-70">
                  {model.name} ({model.provider})
                </button>
              </li>)}
          </ul>
        </div>}
    </div>;
}